import { useMemo, useRef, useState } from "react";

// Ordinamento tabella riutilizzabile: gestisce chiave/direzione e ordina secondo gli accessors.
// Se nessuna colonna è selezionata, restituisce le righe nell'ordine originale.
export function useTableSort(rows, accessors = {}, initial = {}) {
  const [sortKey, setSortKey] = useState(initial.key || null);
  const [sortDir, setSortDir] = useState(initial.dir || "asc");
  const accRef = useRef(accessors);
  accRef.current = accessors;

  const toggleSort = (key) => {
    if (sortKey === key) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortKey(key);
      setSortDir("asc");
    }
  };

  const sorted = useMemo(() => {
    if (!sortKey) return rows;
    const acc = accRef.current[sortKey] || ((r) => r[sortKey]);
    const dir = sortDir === "asc" ? 1 : -1;
    return [...rows].sort((a, b) => {
      const va = acc(a);
      const vb = acc(b);
      const na = parseFloat(va);
      const nb = parseFloat(vb);
      const bothNum =
        va !== "" && vb !== "" && va != null && vb != null && !isNaN(na) && !isNaN(nb);
      if (bothNum) return (na - nb) * dir;
      return (
        String(va ?? "").localeCompare(String(vb ?? ""), "it", {
          numeric: true,
          sensitivity: "base",
        }) * dir
      );
    });
  }, [rows, sortKey, sortDir]);

  return { sorted, sortKey, sortDir, toggleSort };
}
